const steps = [
  {
    step: '01',
    icon: 'ri-compass-3-line',
    title: '진로·계열·직업 탐색',
    description: '흥미 유형과 직업 가치관을 분석해 맞춤 계열·전공·직업을 추천합니다',
    color: 'primary',
  },
  {
    step: '02',
    icon: 'ri-lightbulb-line',
    title: '성격·성향 기반 공부법 검사',
    description: 'VARK 학습 유형과 MBTI 성격을 진단해 나에게 딱 맞는 공부법을 찾아줍니다',
    color: 'accent',
  },
  {
    step: '03',
    icon: 'ri-brain-line',
    title: 'IQ 테스트',
    description: '언어·수리·공간·패턴 영역의 인지능력을 측정해 종합 지능을 산출합니다',
    color: 'secondary',
  },
  {
    step: '04',
    icon: 'ri-book-read-line',
    title: '어휘력·문해력 검사',
    description: '어휘력과 문해력을 정밀 진단해 국어 기초 학력을 점검합니다',
    color: 'primary',
  },
];

export default function HowItWorks() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block text-accent-600 text-sm font-semibold tracking-widest uppercase mb-3">종합 분석</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            5가지 도구로 학생의 공부 데이터를 종합 분석합니다
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            네 가지 검사와 선택과목 추천을 하나로 모아 우리 아이의 강점과 공부법을 정밀하게 진단합니다
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, idx) => (
            <div key={step.step} className="relative">
              {/* Connector */}
              {idx < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 left-[calc(100%-12px)] w-6 h-0.5 bg-background-300 z-10"></div>
              )}

              <div className="bg-background-50 rounded-xl p-6 border border-background-200 h-full">
                {/* Step Number & Icon */}
                <div className="flex items-center gap-3 mb-4">
                  <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${
                    step.color === 'primary' ? 'bg-primary-100' :
                    step.color === 'accent' ? 'bg-accent-100' : 'bg-secondary-100'
                  }`}>
                    <i className={`${step.icon} text-lg ${
                      step.color === 'primary' ? 'text-primary-600' :
                      step.color === 'accent' ? 'text-accent-600' : 'text-secondary-600'
                    }`}></i>
                  </div>
                  <span className={`text-2xl font-bold ${
                    step.color === 'primary' ? 'text-primary-200' :
                    step.color === 'accent' ? 'text-accent-200' : 'text-secondary-200'
                  }`}>{step.step}</span>
                </div>

                <h3 className="font-semibold text-foreground-950 mb-2">{step.title}</h3>
                <p className="text-foreground-600 text-sm leading-relaxed">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}